function initialiseRelatedProducts() {
  document.querySelectorAll('.related-product-wrap .popular-products').forEach(slider => {
    if (slider.swiper) return;
    new Swiper(slider, {
      slidesPerView: 2,
      spaceBetween: 16,
      watchOverflow: true,
      navigation: {
        nextEl: slider.querySelector('.swiper-button-next'),
        prevEl: slider.querySelector('.swiper-button-prev')
      },
      breakpoints: {
        640: { slidesPerView: 3, spaceBetween: 16 },
        990: { slidesPerView: 3, spaceBetween: 16 }
      }
    });
  });
}

initialiseRelatedProducts();
document.addEventListener('shopify:section:load', initialiseRelatedProducts);
